export default function SurveyErrorPage() {
  return (
    <div className="max-w-screen-sm mx-auto p-6 pt-12">
      <h1 className="text-xl font-semibold mb-3">Survey link expired or invalid</h1>
      <p className="text-sm text-gray-700">
        This survey link is no longer valid. Please contact your golf professional
        to request a new survey invitation.
      </p>
    </div>
  );
}
